/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 04.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import {Link} from 'react-router';

import ClassNames from 'classnames';

import _get from 'lodash/get';
import _find from 'lodash/find';
import _isEqual from 'lodash/isEqual';

class ChannelTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`,
      isYoutube: false,
      youtubeStream: null
    };
  }

  componentDidMount() {

    if (!this.props.channel.id) return;

    this.__findYoutubeResource();

    lh.models.asset.methods.getPosterUrl(this.props.channel, {
      crop: {x: 132, y: 132},
      cache: false
    })
      .then((url) => {
        this.setState({picture: url});
      });
  }

  componentWillReceiveProps(newProps) {

    if (newProps.channel.id !== this.props.channel.id) {
      this.__findYoutubeResource(newProps);

      lh.models.asset.methods.getPosterUrl(newProps.channel, {
        crop: {x: 132, y: 132},
        cache: false
      })
        .then((url) => {
          this.setState({picture: url});
        });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return _get(this.props, 'channel.id') !== _get(nextProps, 'channel.id')
      || this.state.picture !== nextState.picture
      || this.props.isSelected !== nextState.isSelected
      || !_isEqual(_get(nextProps, 'channel', null), _get(this.props, 'channel', null));
  }

  __findYoutubeResource(props = this.props) {
    let youtubeResource = _find(_get(props.channel, 'resources', []), (resource) => {

      return resource.type === 'stream' && resource.stream_type.indexOf('youtube') !== -1;
    });

    if (youtubeResource) {
      this.setState({
        isYoutube: true,
      });

      lh.models.viewAsset.methods.getMediaUrl(props.channel, null, {is_youtube: true})
        .then((stream) => {
          let parse = youtubeResource.stream_type
              .replace('youtube+user', 'https://www.youtube.com/user/')
              .replace('youtube+channel', 'https://www.youtube.com/channel/') + '';

          this.setState({
            youtubeStream: parse + stream
          });

        }, (reason) => {
          //TODO: SHOW ERROR CODE

          console.log('Failed:', reason);
        });
    }
  }

  render() {

    let channelTileClass = ClassNames({
      'col-last': this.props['col'] === 8,
      'channel block-1 bg-black radius showcase-row-channel-block': true
    });

    if (this.state.isYoutube) {

      return (<div className={channelTileClass}>
        <a href={this.state.youtubeStream} target="_blank" rel="noopener noreferrer" className="channel-link profile-show hover pad-lr youtube-link">
          <div className="channel-poster">
            <img src={this.state.picture} alt={this.props.channel.title} className="ico-channel-profile" />
          </div>
          {_get(Config, 'show_youtube_channel_title', true) && <span className="block-note" style={{bottom: '5px', left: '5px', paddingRight: '25px'}}>{this.props.channel.title}</span>}
          <div className="with-youtube color-white">
            <i className="ic ic-youtube ic-16px"></i>
          </div>
        </a>
      </div>)
    }

    let love = '';
    if (this.props.channel.is_favorite) {
      love = <div className="love">
        <i className="ic ic-fav-in-fill ic-14px"></i>
      </div>;
    }

    let lock = '';
    if (!this.props.channel.is_purchased && !this.props.channel.is_available && !this.props.channel.is_free) {

      lock = <div className="lock">
        <i className="ic ic-lock ic-14px"></i>
      </div>;
    }

    return (
      <div className={channelTileClass} onClick={this.props.onChannelSelect.bind(this, this.props.channel, this.props.row, this.props.col)}>
        <a href="javascript:void(0)" className="channel-link profile-show hover pad-lr">
          {this.props.isSelected && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
            <i className="ic ic-selected-dot ic-14px asset-selected-icon"></i>
          </ReactCSSTransitionGroup>}
          <div className="channel-poster">
            <img src={this.state.picture} alt={this.props.channel.title} className="ico-channel-profile" />
          </div>
          {_get(Config, 'show_channel_title', true) && <span className="block-note" style={{bottom: '5px', left: '5px', paddingRight: '25px'}}>{this.props.channel.title}</span>}
          {lock}
          {love}
        </a>
      </div>
    );
  }
}

ChannelTile.propTypes = {
  channel: PropTypes.object.isRequired,
  onChannelSelect: PropTypes.func.isRequired
};

export default connect(({auth: {user}}) => ({user}))(ChannelTile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Tile/Channel/channel-tile.js